import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { SetColorsService } from 'core'

@Component({
  selector: 'bmprod-select-license-popup',
  templateUrl: './bmprod-select-license-popup.component.html',
  styleUrls: ['./bmprod-select-license-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmprodSelectLicensePopupComponent implements OnInit {
  colorSettingsMode = false

  constructor(private setColorsService: SetColorsService) {}

  ngOnInit(): void {
    this.getColorSettingsMode()
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
